'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = undefined;

var _partialRight2 = require('lodash/partialRight');

var _partialRight3 = _interopRequireDefault(_partialRight2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = require('reselect');

var _capeField = require('../capeField');

var _FileUploading = require('./FileUploading');

var _FileUploading2 = _interopRequireDefault(_FileUploading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = (0, _reselect.createSelector)((0, _partialRight3.default)(_capeField.getFieldState, {}), function (_ref) {
  var meta = _ref.meta,
      isSaving = _ref.isSaving,
      savedProgress = _ref.savedProgress,
      savedValue = _ref.savedValue,
      value = _ref.value;
  return {
    isSaving: isSaving,
    savedProgress: savedProgress,
    savedValue: savedValue,
    value: meta ? _extends({}, meta, value) : value
  };
});

exports.default = (0, _capeField.createConnect)(mapStateToProps)(_FileUploading2.default);


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/FileUpload/FileUploadingContainer.js
// module id = 686
// module chunks = 0